import React from "react"
import styled from "styled-components"
import isMobile from "is-mobile"
import { View } from "./"

const width = 1.76
const height = 0.8

export default styled(View).attrs(() => ({ color: "border" }))`
  position: relative;
  left: ${width / -2}rem;
  width: ${width}rem;
  height: ${height}rem;
  border: 0;
  border-bottom: 1px solid currentColor;
  border-top: 1px solid currentColor;
  margin-top: 5px;
  :hover {
    opacity: 0.6;
  }
  transition: opacity 250ms ease;
  cursor: pointer;
`
